export default {
  name: "CategoriesSolid",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M10.25 5v3.25a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h3.25a2 2 0 0 1 2 2zM27 21.75h-3.25a2 2 0 0 0-2 2V27c0 1.1.9 2 2 2H27a2 2 0 0 0 2-2v-3.25a2 2 0 0 0-2-2zm-9.38 0h-3.25a2 2 0 0 0-2 2V27c0 1.1.9 2 2 2h3.25a2 2 0 0 0 2-2v-3.25a2 2 0 0 0-2-2zm-9.37 0H5a2 2 0 0 0-2 2V27c0 1.1.9 2 2 2h3.25a2 2 0 0 0 2-2v-3.25a2 2 0 0 0-2-2zM27 12.38h-3.25a2 2 0 0 0-2 2v3.25c0 1.1.9 2 2 2H27a2 2 0 0 0 2-2v-3.25a2 2 0 0 0-2-2zm-9.38 0h-3.25a2 2 0 0 0-2 2v3.25c0 1.1.9 2 2 2h3.25a2 2 0 0 0 2-2v-3.25a2 2 0 0 0-2-2zm-9.37 0H5a2 2 0 0 0-2 2v3.25c0 1.1.9 2 2 2h3.25a2 2 0 0 0 2-2v-3.25a2 2 0 0 0-2-2zM27 3h-3.25a2 2 0 0 0-2 2v3.25c0 1.1.9 2 2 2H27a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm-9.38 0h-3.25a2 2 0 0 0-2 2v3.25c0 1.1.9 2 2 2h3.25a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2z",
  },
}
